'use client';

import { c as _c } from "react/compiler-runtime";
import { type FC, type ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Tooltip from '@mui/material/Tooltip';
import { ROUTES } from '@/app/routes';
interface SideMenuItemProps {
  isMenuOpen: boolean;
  icon: ReactNode;
  children: string;
  route: string;
}
export const SideMenuItem: FC<SideMenuItemProps> = t0 => {
  const $ = _c(35);
  const {
    isMenuOpen,
    icon,
    children,
    route
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname || $[1] !== route) {
    t1 = pathname === ROUTES.quotes.create ? pathname === route : pathname.startsWith(route);
    $[0] = pathname;
    $[1] = route;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isActive = t1;
  let t2;
  if ($[3] !== isActive) {
    t2 = theme => ({
      display: "block",
      backgroundColor: isActive ? theme.palette.primary.dark : undefined,
      "&:hover": {
        backgroundColor: theme.palette.primary.altern
      }
    });
    $[3] = isActive;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      popper: {
        modifiers: [{
          name: "offset",
          options: {
            offset: [0, -10]
          }
        }]
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isMenuOpen ? "initial" : "center";
  let t5;
  if ($[6] !== t4) {
    t5 = {
      minHeight: 55,
      justifyContent: t4,
      px: 2.5
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isActive || $[9] !== isMenuOpen) {
    t6 = t7 => {
      const {
        palette
      } = t7;
      return {
        minWidth: 0,
        mr: isMenuOpen ? 3 : "auto",
        justifyContent: "center",
        color: isActive ? palette.secondary.light : palette.getContrastText(palette.primary.main)
      };
    };
    $[8] = isActive;
    $[9] = isMenuOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== icon || $[12] !== t6) {
    t7 = <ListItemIcon sx={t6}>{icon}</ListItemIcon>;
    $[11] = icon;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = isMenuOpen ? 1 : 0;
  let t9;
  if ($[14] !== t8) {
    t9 = {
      opacity: t8
    };
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = isActive ? "secondary.light" : "white";
  let t11;
  if ($[16] !== t10) {
    t11 = {
      fontWeight: 600,
      color: t10,
      fontSize: 16
    };
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== children || $[19] !== t11 || $[20] !== t9) {
    t12 = <ListItemText sx={t9} primaryTypographyProps={t11}>{children}</ListItemText>;
    $[18] = children;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isActive || $[23] !== route || $[24] !== t12 || $[25] !== t5 || $[26] !== t7) {
    t13 = <ListItemButton sx={t5} selected={isActive} href={route}>{t7}{t12}</ListItemButton>;
    $[22] = isActive;
    $[23] = route;
    $[24] = t12;
    $[25] = t5;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== children || $[29] !== isMenuOpen || $[30] !== t13) {
    t14 = <Tooltip title={children} placement="right" disableHoverListener={isMenuOpen} componentsProps={t3}>{t13}</Tooltip>;
    $[28] = children;
    $[29] = isMenuOpen;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t2) {
    t15 = <ListItem disablePadding={true} sx={t2} divider={true}>{t14}</ListItem>;
    $[32] = t14;
    $[33] = t2;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};